import { createFileRoute } from "@tanstack/react-router"
import Component from "./-components/screen"

export const Route = createFileRoute("/(app)/_layout/activity/")({
  component: Component,
})